import React, { memo } from 'react'
import { Player } from '@lottiefiles/react-lottie-player'
import PropTypes from 'prop-types'

function LottiePlayer({ animationData, loop, autoplay, className, lottieRef }) {
  return (
    <div className={className}>
      <Player
        autoplay={autoplay}
        keepLastFrame
        loop={loop}
        lottieRef={lottieRef}
        src={animationData}
      />
    </div>
  )
}

export default memo(LottiePlayer)

LottiePlayer.propTypes = {
  animationData: PropTypes.objectOf(PropTypes.string).isRequired,
  loop: PropTypes.bool,
  lottieRef: PropTypes.node,
  autoplay: PropTypes.bool,
  className: PropTypes.string
}

LottiePlayer.defaultProps = {
  className: '',
  loop: true,
  lottieRef: null,
  autoplay: true
}
